import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { TrashIcon } from 'components/icons';
import { DeleteSiteAreaModalProps } from './types';

export function DeleteSiteAreaModal(
  props: DeleteSiteAreaModalProps,
): ReactElement {
  const { isOpen, onCancel, onConfirm, siteArea } = props;

  const onAction = (): void => {
    onConfirm?.(siteArea);
  };

  return (
    <Modal
      open={isOpen}
      setOpen={onCancel}
      size="xs"
      title={`Delete "${siteArea?.name}" Site Area?`}
      titleAlignment="center"
      textAlignment="center"
      onAction={onAction}
      actionText="Delete Site Area"
      actionButtonTheme="danger"
      actionIcon={TrashIcon}
    />
  );
}
